const features = [
  {
    icon: 'ri-group-line',
    title: '多元兴趣圈子',
    description: '六大核心兴趣领域，从旅行美食到科技艺术，每个圈子都有活跃的用户群体和高质量内容，轻松找到你的同好。',
  },
  {
    icon: 'ri-star-line',
    title: '优质内容精选',
    description: '严格的社区内容审核机制，确保每篇文章都是用心之作。点赞评论机制让好内容脱颖而出，拒绝低质量水文。',
  },
  {
    icon: 'ri-chat-smile-2-line',
    title: '温暖社区氛围',
    description: '友好互助的社区文化，每个成员都被尊重和鼓励。在这里分享经验、交流心得，让每次互动都充满温度。',
  },
  {
    icon: 'ri-rocket-line',
    title: '共同成长平台',
    description: '不仅是内容消费，更是技能提升和视野拓展的平台。跟随达人学习，分享自己的进步，与社区一起成长。',
  },
];

export default function FeaturesSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            为什么选择蘑菇社区
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            我们用心打造每一个细节，只为给你最好的社区体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="bg-background-100 rounded-xl p-6 text-center hover:bg-background-200/70 transition-colors"
            >
              <div className="w-14 h-14 mx-auto mb-4 rounded-xl bg-accent-100 flex items-center justify-center">
                <i className={`${feature.icon} text-2xl text-accent-600`}></i>
              </div>
              <h3 className="font-heading font-semibold text-base text-foreground-950 mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}